var _defs, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPractitionerMaster = function SvgPractitionerMaster(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.925,
    height: 16.81,
    viewBox: "0 0 15.925 16.81",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6f6f6f;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-classroom",
    className: "cls-1",
    d: "M5.654,2A1.769,1.769,0,1,0,7.424,3.769,1.769,1.769,0,0,0,5.654,2Zm3.539.885V4.654h7.963v7.078H10.078V13.5H17.6a1.329,1.329,0,0,0,1.327-1.327V4.212A1.329,1.329,0,0,0,17.6,2.885ZM4.769,6.424A1.769,1.769,0,0,0,3,8.193V13.5H8.308V8.193h5.308V6.424H4.769Zm0,1.769H6.539v3.539H4.769Zm.885,7.078A1.769,1.769,0,1,0,7.424,17.04,1.769,1.769,0,0,0,5.654,15.271Zm5.308,0a1.769,1.769,0,1,0,1.769,1.769A1.769,1.769,0,0,0,10.963,15.271Zm5.308,0A1.769,1.769,0,1,0,18.04,17.04,1.769,1.769,0,0,0,16.271,15.271Z",
    transform: "translate(-3 -2)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPractitionerMaster, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Practitioner_Master.10f5f7be.svg";
export { ForwardRef as ReactComponent };